import { datasetType } from "../constanst/index";
import { ActionWithPayload } from "../types/ActionsType";
import {
  Datasets,
  datasetsState,
  Download,
  DatasetRoutes,
} from "../types/datasetsType";
import { Exception } from "../types/exceptionType";

let error: Exception = { status: "", message: "", data: {} };
let download: Download = {
  status: "",
  code: 0,
  message: "",
  data: { url: "" },
};
const datasets: Datasets = { elements: [], marker: "" };
const datasetRoutes: DatasetRoutes[] = [];
const initialState = {
  datasets: {
    loading: false,
    data: datasets,
    error: error,
  },
  downlodUrl: {
    loading: false,
    data: download,
    error: error,
  },
  datasetRoutes: datasetRoutes,
};

const datasetsReducer = (
  state = initialState,
  action: ActionWithPayload<any>
): datasetsState => {
  switch (action.type) {
    case datasetType.FETCH_DATASETS_REQUEST:
      return {
        ...state,
        datasets: {
          ...state.datasets,
          loading: true,
        },
      };

    case datasetType.FETCH_DATASETS_SUCCESS:
      const newElements = [
        ...state.datasets.data.elements,
        ...action.payload.elements,
      ];
      newElements?.map((item: any, idx: number) => (item.key = idx));
      return {
        ...state,
        datasets: {
          loading: false,
          data: {
            elements: newElements,
            marker: action.payload.marker,
          },
          error: error,
        },
      };
    case datasetType.FETCH_DATASETS_FAILURE:
      return {
        ...state,
        datasets: {
          loading: false,
          data: {},
          error: action.payload,
        },
      };
    case datasetType.FETCH_DOWNLOAD_URL_REQUEST:
      return {
        ...state,
        downlodUrl: {
          ...state.downlodUrl,
          loading: true,
        },
      };
    case datasetType.FETCH_DOWNLOAD_URL_SUCCESS:
      return {
        ...state,
        downlodUrl: {
          loading: false,
          data: action.payload,
          error: error,
        },
      };
    case datasetType.FETCH_DOWNLOAD_URL_FAILURE:
      return {
        ...state,
        downlodUrl: {
          loading: false,
          data: download,
          error: action.payload,
        },
      };
    case datasetType.CLEAN_DATASET_ELEMENTS:
      return {
        ...state,
        datasets: {
          loading: false,
          data: {
            elements: [],
            market: "",
          },
          error: error,
        },
      };
    case datasetType.ADD_DATASET_ROUTE: {
      return {
        ...state,
        datasetRoutes: [...state.datasetRoutes, action.payload],
      };
    }
    case datasetType.CLEAN_DATASET_ROUTE: {
      return {
        ...state,
        datasetRoutes: [],
      };
    }
    case datasetType.UPDATE_DATASET_ROUTE: {
      return {
        ...state,
        datasetRoutes: action.payload,
      };
    }
    default:
      return state;
  }
};

export default datasetsReducer;
